module.exports = __webpack_public_path__ + "static/img/detainbackrgound.be29d50f.png";